export const photos = [
  {
    id: 1,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Lush Life - Airbnb'
  },
  {
    id: 2,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Lush Life - Airbnb'
  },
  {
    id: 3,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Lush Life - Airbnb'
  },
  {
    id: 4,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Lush Life - Airbnb'
  },
  {
    id: 5,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Lush Life - Airbnb'
  },
  {
    id: 6,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Lush Life - Airbnb'
  },
  {
    id: 7,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Lush Life - Airbnb'
  },
  {
    id: 8,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Lush Life - Airbnb'
  },
  {
    id: 9,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Lush Life - Airbnb'
  },
  {
    id: 10,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  },
  {
    id: 11,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  },
  {
    id: 12,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  },
  {
    id: 13,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  },
  {
    id: 14,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  },
  {
    id: 15,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  },
  {
    id: 16,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  },
  {
    id: 17,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  },
  {
    id: 18,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  },
  {
    id: 19,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  },
  {
    id: 20,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  },
  {
    id: 21,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  },
  {
    id: 22,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  },
  {
    id: 23,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  },
  {
    id: 24,
    country: 'antigua-and-barbuda',
    location: 'antigua-accommodation',
    name: 'Keyonna Beach Resort'
  }
]